<div class="remote-attachments">
  <div class="title">
    {{ title || 'Archivos adjuntos existentes' }}
    @if (showReplaceText) {
      <span> (Serán reemplazados por los que vas a subir) </span>
    }
  </div>
  <ul>
    @for (file of remoteAttachments; track file; let i = $index) {
      <li>
        <span (click)="downloadRemoteAttachment(file)">
          {{ file.name }}
        </span>
        <div class="options">
          @if (file.isDownloadingRemoteAttachment) {
            <mat-spinner class="primary-spinner"></mat-spinner>
          }
          <button
            mat-icon-button
            type="button"
            color="warn"
            (click)="confirmRemoteAttachmentDeletion(file, i)"
            [disabled]="isDeletingRemoteAttachment || file.isDownloadingRemoteAttachment"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </li>
    }
  </ul>
</div>
